var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-form disabled-print",on:{"click":function($event){return _vm.$router.push('/')}}},[_c('el-image',{attrs:{"src":require('@/assets/images/logo.png')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }